import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { LOGO_WHITE } from '@/assets/brand';
import { NAMESPACE } from '@/constants';
import { LoginButton } from './components';
import { useLogin } from './hooks/useLogin';
import {
  LoginContent,
  LoginLogo,
  LoginPage,
  LoginSubtitle,
  StyledAlert
} from './Login.styles';

const Login: FC = () => {
  const { signInError, signOutError, handleSignIn } = useLogin();
  const { t } = useTranslation(NAMESPACE.LOGIN_PAGE);

  return (
    <LoginPage>
      <LoginContent>
        <LoginLogo src={LOGO_WHITE} alt="Skyrise" />
        <LoginSubtitle>{t('pleaseUseSkyriseCredentials')}</LoginSubtitle>
        <LoginButton onClick={handleSignIn} />
        <div role="alert" aria-live="polite">
          {signInError && <StyledAlert message={signInError} type="error" showIcon />}
          {signOutError && <StyledAlert message={signOutError} type="error" showIcon />}
        </div>
      </LoginContent>
    </LoginPage>
  );
};

export default Login;
